export class Utils {

  static hasOneOfOrNoRestriction(availableItems: Array<string>, allowedItems: Array<string>) {
    if (allowedItems == null || allowedItems.length <= 0) {
      return true;
    }

    if (availableItems == null || availableItems.length <= 0) {
      return false;
    }

    let hasOneOf: boolean = false;
    for (let availabe of availableItems) {
      for (let allowed of allowedItems) {
        allowed = allowed.toUpperCase();
        if (allowed.toUpperCase() === availabe.toUpperCase()) {
          hasOneOf = true;
          break;
        }
      }
    }
    return hasOneOf;
  }
}




// WEBPACK FOOTER //
// ./src/app/core/helpers/utils.ts